import { useState } from "react";
import { SCENE_PRESETS, type ScenePreset } from "../scenes";
import { useViewerStore } from "../state/viewerStore";

export function ScenePicker() {
  const sceneUrl = useViewerStore((s) => s.sceneUrl);
  const setSceneUrl = useViewerStore((s) => s.setSceneUrl);
  const [open, setOpen] = useState(false);

  const current = SCENE_PRESETS.find((s) => s.url === sceneUrl);

  function pick(preset: ScenePreset) {
    setSceneUrl(preset.url);
    setOpen(false);
  }

  return (
    <div className="scene-picker">
      <button className="scene-picker-btn" onClick={() => setOpen((o) => !o)}>
        <span className="dot" data-cat={current?.category ?? "sample"} />
        <span className="label">{current?.label ?? "Custom scene"}</span>
        <span className="caret">{open ? "▴" : "▾"}</span>
      </button>
      {open && (
        <div className="scene-picker-menu">
          {(["venue", "indoor", "sample", "outdoor"] as const).map((cat) => {
            const items = SCENE_PRESETS.filter((s) => s.category === cat);
            if (items.length === 0) return null;
            return (
              <div className="group" key={cat}>
                <div className="group-label">{cat}</div>
                {items.map((s) => (
                  <button
                    key={s.id}
                    className={s.url === sceneUrl ? "item active" : "item"}
                    onClick={() => pick(s)}
                  >
                    <span className="dot" data-cat={s.category} />
                    <div className="item-text">
                      <div className="item-label">{s.label}</div>
                      {s.description && <div className="item-desc">{s.description}</div>}
                    </div>
                  </button>
                ))}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
